<template>
  <div class="job-details">
    <job-left-menu>

      <nav-back-button to="/jobs?filter=All">
        {{$t('job.details.back')}}
      </nav-back-button>

        <card type="user" plain card-body-classes="px-0" footer-classes="p-0" class="mb-0 px-2"
              v-if="job">
          <div class="d-flex flex-column">
            <div class="d-flex text-overflow align-items-center">
              <base-avatar :src="job.logo" :name="job.title" :circle="false" size="sm" alt="User avatar"/>
              <div class="ml-2">
                <el-tooltip :content="$t('job.details.menu.jobTitle')" placement="top-start">
                  <div class="font-weight-bold mb-0 text-overflow">{{job.title}}</div>
                </el-tooltip>

                <div class="d-flex align-items-center text-overflow" v-if="job.apply_email">
                  <i class="nc-icon nc-email-85"></i>&nbsp;
                  <el-tooltip :content="job.apply_email" placement="top-start">
                    <div class="description">{{job.apply_email}}</div>
                  </el-tooltip>
                </div>

                <div class="d-flex align-items-center text-overflow" v-if="job.apply_url">
                  <i class="nc-icon nc-globe-2"></i>&nbsp;
                  <a :href="job.apply_url" target="_blank" rel="noopener">
                    {{$t('job.details.applyUrl')}}
                  </a>
                </div>
              </div>
            </div>
            <div class="mt-4">
              <div class="d-flex align-items-center justify-content-between text-overflow" v-if="job.client && job.client.name">
                <span>{{$t('generic.client')}} &nbsp;</span>
                <router-link :to="`/contacts/clients/${job.client_uuid}`">
                  {{job.client.name}}
                </router-link>
              </div>

              <div class="d-flex align-items-center justify-content-between text-overflow" v-if="hasClientAddresses">
                <span>{{$t('client.edit.client_addresses')}}</span>
                <span v-html="getAddress(job.client.addresses)"></span>
              </div>
            </div>
          </div>

        </card>

        <hr>

        <nav-list :items="navigationItems"
                  @on-delete-click="deleteJobBoard"
                  @on-approve-click="approveJob"
                  @on-reject-click="rejectJob"
                  @on-upgrade-click="upgradeJob"
        >
        </nav-list>

        <job-upgrade-modal v-if="showUpgradeModal"
                           :show.sync="showUpgradeModal"
                           :title="$t('job.details.upgradeJob')">
        </job-upgrade-modal>
    </job-left-menu>
    <div class="row">
      <div class="col-12">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
  import { entities } from 'src/config/routeTypes'
  import { mapMutations, mapState } from 'vuex'
  import jobsModule from 'src/store/modules/jobs'
  import JobLeftMenu from './JobLeftMenu'
  import JobService from 'src/services/JobService'
  import { getRouteName, routeTypes } from 'src/config/routeTypes'
  import JobUpgradeModal from 'src/views/admin/jobs/JobUpgradeModal'
  export default {
    name: 'job-details',
    components: {
      JobUpgradeModal,
      JobLeftMenu
    },
    data () {
      return {
        job: {},
        error: null,
        deleteActive: false,
        showUpgradeModal: false
      }
    },
    computed: {
      ...mapState({
        jobFromStore: state => state.jobs.currentJob
      }),
      showUpgradeOptions() {
        let products = this.$store.state.config.products
        return products.job_up_sell && products.job_up_sell.length
      },
      shouldCheckJob() {
        return this.job.status === 'check'
      },
      navigationItems () {
        let activateText = this.job.status === 'pause'
          ? this.$t('job.details.menu.activate')
          : this.$t('job.details.menu.pause')
        return [
          {
            type: 'group',
            name: 'Job settings'
          },
          {
            routeName: 'job_dashboard',
            name: this.$t('job.details.menu.dashboard')
          },
          {
            routeName: 'job_edit',
            name: this.$t('job.details.menu.edit'),
            hide: !this.$can('admin-jobs-crud')
          },
          {
            routeName: 'job_applicants',
            name: this.$t('job.details.menu.applicants')
          },
          {
            routeName: 'job_activation',
            name: activateText
          },
          {
            name: this.$t('generic.approve'),
            title: 'approve',
            hide: !this.$can('admin-jobs-crud') || !this.shouldCheckJob
          },
          {
            name: this.$t('generic.reject'),
            title: 'reject',
            hide: !this.$can('admin-jobs-crud') || !this.shouldCheckJob
          },
          {
            name: this.$t('generic.upgrade'),
            title: 'upgrade',
            hide: !this.$can('admin-jobs-crud') || !this.showUpgradeOptions,
            classes: 'text-success',
            icon: 'nc-icon nc-money-coins'
          },
          {
            name: this.$t('generic.delete.title'),
            title: 'delete',
            hide: !this.$can('admin-jobs-crud')
          },
        ]
      },
      hasClientAddresses() {
        return this.job.client && this.job.client.addresses && this.job.client.addresses.length > 0;
      }
    },
    methods: {
      ...mapMutations('jobs', [jobsModule.types.SET_CURRENT_JOB]),
      async deleteJobBoard () {
        await this.$confirm(this.$t('generic.delete.confirm', {title: this.job.title, entity: entities.JOB}), {
          dangerouslyUseHTMLString: true
        })
        await JobService.delete(this.job.uuid)
        this.$router.push({name: getRouteName(routeTypes.LIST, entities.JOB)})
      },
      async approveJob() {
        let newStatus = 'active'
        await JobService.verify(this.job.uuid, {
          status: newStatus
        })
        this.job.status = newStatus
      },
      async rejectJob() {
        let newStatus = 'rejected'
        await JobService.verify(this.job.uuid, {
          status: newStatus
        })
        this.job.status = newStatus
      },
      getAddress (addresses) {
        let primaryAddress = addresses.find(a => a.primary === true || a.primary === 1)
        if (!primaryAddress) {
          return ''
        }
        return ` ${primaryAddress.address_line_1}, <br/> ${primaryAddress.city}`
      },
      upgradeJob() {
        this.showUpgradeModal = true
      }
    },
    watch: {
      jobFromStore (newValue) {
        this.job = {
          ...newValue
        }
      }
    },
    async beforeRouteEnter (to, from, next) {
      try {
        let id = to.params.id
        let res = await JobService.getById(id)
        let job = res.data
        if (job) {
          next(vm => {
            vm.job = job
            vm[jobsModule.types.SET_CURRENT_JOB](job)
          })
        } else {
          next(vm => vm.error = 'No data')
        }
      } catch (e) {
        next(vm => vm.error = e)
      }
    },
  }
</script>
<style lang="scss">
  .job-details {
    .job-image {
      width: 100px;
      height: 100%;
    }
    .job-link {
      font-size: $font-size-large;
    }
    .layout-margin {
      margin-top: 62px;
    }
  }
</style>
